export function updateUser(name, email) {
  return {
    type: 'UPDATE_USER', // Sempre precisa dessa chave para o redux
    name,
    email
  };
}